@if (range(); as range) {
  <div class="unavailability-range">
    <onyx-icon class="f-muted" name="clock-filled" [size]="16"></onyx-icon>

    {{ range.from! | onyxDate: 'date-dot' : { endDate: range.to! } }}
  </div>
} @else {
  -
}
